import ChipMultiSelect from "../components/ChipMultiSelect/ChipMultiSelect";

export const SelectProps = (
  disabled,
  UiValue,
  label,
  setUiValue,
  isSingle,
  CheckInReal,
  AllFieldsRealTimeCheck,
  name,
  errors,
  SelectableDataArray,
  isEnglish
) => {
  const props = {
    disabled: !!disabled,
    labelId: "demo-simple-select-label",
    id: "demo-simple-select",
    value: UiValue,
    label: label ?? "",
    onChange: (event) => {
      setUiValue(event.target.value);
    },
    multiple: isSingle ? false : true,
    error: CheckInReal
      ? AllFieldsRealTimeCheck && AllFieldsRealTimeCheck[name]
      : errors && !!errors[name],
    color: "colorPrimer",
    renderValue: (selected) =>
      isSingle ? (
        selected?.length > 29 ? (
          `${selected?.slice(0, 29)}...`
        ) : (
          selected
        )
      ) : (
        <ChipMultiSelect
          selected={selected}
          UiValue={UiValue}
          SelectableDataArray={SelectableDataArray}
          setUiValue={setUiValue}
          isEnglish={isEnglish}
        />
      ),
  };

  return props;
};
